import { Progress as BaseProgress } from '@base-ui/react/progress'
import { twMerge } from 'tailwind-merge'
import { ProgressLabel } from './nested/label'
import { ProgressTrack } from './nested/track'
import { ProgressIndicator } from './nested/indicator'
import { ProgressValue } from './nested/value'
import type { PartProps } from '../../lib/part-props'

interface ProgressRootProps extends PartProps<BaseProgress.Root.Props> {
  className?: string
}

function Progress({ className, children, ...props }: ProgressRootProps) {
  return (
    <BaseProgress.Root className={twMerge('grid w-full grid-cols-2 gap-y-2', className)} {...props}>
      {children}
    </BaseProgress.Root>
  )
}

Progress.Label = ProgressLabel
Progress.Track = ProgressTrack
Progress.Indicator = ProgressIndicator
Progress.Value = ProgressValue

export { Progress }
